<template>
  <div class="fila-atendimento">
    <div class="d-flex align-center justify-center py-8 bg-default">
      <v-container>
        <div class="text-center">
          <h4 class="secondary-font">Fila de espera</h4>
          <h5 class="secondary-font text--secondary mt-2">
            Atenção, no momento você está na fila de atendimento, <b>permaneça nessa página</b>
          </h5>
        </div>
      </v-container>
    </div>
    <div v-if="queueStatus" class="loading-container">
      <div class="loading-text">
        <div></div>
        Fique nesta página para evitar perder o atendimento
      </div>

      <div class="countdown">
        <div class="countdown-time">Seu atendimento começará em breve</div>
      </div>
      <div>
        <v-progress-circular indeterminate width="3" color="primary"></v-progress-circular>
      </div>
      <div class="last-update">Ultima atualização: {{ dateFormatted }}</div>
      <div class="mt-2">
        Para garantir seu atendimento, permaneça nesta tela e evite trocar de aplicativo ou sair. Caso isso ocorra, você
        será redirecionado para o final da fila de espera
      </div>
    </div>
    <div v-else class="ma-5">
      <v-skeleton-loader class="mb-10" type="text"> </v-skeleton-loader>
      <v-skeleton-loader type="text"> </v-skeleton-loader>
      <v-skeleton-loader type="text"> </v-skeleton-loader>
      <v-skeleton-loader class="mb-7 d-flex justify-center" type="avatar"> </v-skeleton-loader>
      <v-skeleton-loader type="text"> </v-skeleton-loader>
    </div>
  </div>
</template>
<script>
import meetingService from '@/services/meeting'

export default {
  name: 'FilaAtendimento',
  props: {
    idAsoMeetingRoom: {
      required: true
    }
  },
  data() {
    return {
      timer: null,
      abortController: new AbortController(),
      queueStatus: null
    }
  },
  computed: {
    dateFormatted() {
      if (this.queueStatus) {
        return new Date(this.queueStatus.lastUpdate).toLocaleTimeString('pt-br')
      }
      return ''
    }
  },
  methods: {
    async initQueueStatus() {
      try {
        const { data } = await meetingService.queueStatus(this.idAsoMeetingRoom)
        this.queueStatus = data
        if (data.meetingRoom) {
          clearInterval(this.timer)
          const newUrl = `/sala-atendimento?room=${data.meetingRoom}&id=${this.idAsoMeetingRoom}`
          window.location.href = newUrl
        }
      } catch (error) {
        console.log(error)
        this.$showErrorMessage('Não foi possível entrar na sala de atendimento')
        this.$router.push({ name: 'dashboard' })
      }
    }
  },
  beforeDestroy() {
    // this.eventSource.close()
    clearInterval(this.timer)
    meetingService.leaveQueue(this.idAsoMeetingRoom)
  },
  mounted() {
    if (this.idAsoMeetingRoom) {
      this.initQueueStatus()
      this.timer = setInterval(this.initQueueStatus, 5000)
    }
  }
}
</script>
<style scoped>
.fila-atendimento {
  /* height: 100%; */
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  gap: 15px;
}

.loading-text {
  padding: 20px;
  font-size: 0.8rem;
  text-align: center;
}

.last-update {
  margin-top: 40px;
  justify-self: end;
  font-size: 0.8rem;
}

.countdown {
  display: flex;
  flex-direction: column;
  color: 'primary';
  justify-content: center;
  justify-items: center;
  align-items: center;
  align-content: center;
  text-align: center;
}

.countdown-time {
  font-size: 2rem;
}

.countdown-text {
  font-size: 0.9rem;
}

.countdown-measure {
  margin-top: -15px;
  margin-left: 2px;
  font-size: 0.9rem;
  width: 100%;
}

.hidden {
  display: none;
}
</style>
